<template>
  <div class="l_walk">
    <div class="container">
      <div class="content">
        <div v-for="(data, index) in this.faqs" :key="index" class="faqlist">
          <Accordion
            :ref="data.id"
            :question="data.question"
            :ans="data.a"
            :innerPageLink="scrollToAnchorPoint"
          ></Accordion>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import faqs from '@/components/Walk/faq'
import Accordion from '@/components/Walk/FAQAccordion'
import { FactoryTrack } from '@/constant/firebase'

export default {
  name: 'FAQWalk',
  components: {
    Accordion
  },
  data: function() {
    return {
      faqs
    }
  },
  created() {
    document.title = 'ウォークスタンプ Q&A'
  },
  methods: {
    ...mapActions('Native', ['actionOpenWalk']),
    ...mapActions('Analytics', ['trackEvent']),
    openWalk: function() {
      this.trackEvent(FactoryTrack.createWalk())
      this.actionOpenWalk()
    },
    scrollToAnchorPoint(refName) {
      this.trackEvent(FactoryTrack.createScrollToAnchorPoint(refName))
      // 指定されたFAQのaccordionを探し、そのforceOpenをよぶ
      const el = this.$refs[refName][0]
      el.forceOpen()
    }
  }
}
</script>

<style lang="scss" scoped>
.l_walk {
  width: 100%;
  min-height: 100%;
  background-color: #ffffff;
  text-align: center;

  h3 {
    color: #602209;
    font-family: 'HiraKakuPro-W6', sans-serif;
  }
  .content {
    background-color: #ffffff;
    text-align: left;
    padding: 20px 0;

    hr {
      margin-top: 10px;
      margin-bottom: 10px;
      border: none;
      border-bottom: 1px solid #efb90f;
    }
    .faqlist {
      border-bottom: 1px solid #e4e4e4;
    }
  }
}
</style>
